// extracted by mini-css-extract-plugin
module.exports = {"comments":"e_Ie","related":"e_Je","breadCrumbs":"e_Ke","postTags":"e_Le","sidebarPostNav":"e_Me"};